angular.module('leanlaw').controller('AttorneyRevenueUnallocatedSidebarCtrl', ['$scope', '$rootScope', '$q', '$filter', '$stateParams', '$state', "alerts", function ($scope, $rootScope, $q, $filter, $stateParams, $state, alerts) {
  $scope.filter = {
    include: {}
  };
  $scope.filter.include.matters = false;
  // $scope.filter.include.accounting = false;

  // Fires immediately on filter creation
  $scope.$watch("filter", () => {
    $rootScope.$broadcast("report-sidebar-filterchange", $scope.filter);
  }, true);

  // Necessary when there's an activate function in the controller
  $rootScope.$on("filterDependency-ready", () => {
    $rootScope.$broadcast("report-sidebar-filterchange", angular.copy($scope.filter));
  });
}]);